// extracted by mini-css-extract-plugin
export default {"header1":"styles_header1__G4u0q","block1":"styles_block1__kKL3m","tableContainer":"styles_tableContainer__OdBEe"};